import "@polymer/polymer/polymer-legacy.js";
import "@polymer/polymer/lib/utils/debounce.js";
import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { getDefaultStore } from "./stores/root-store";
import APIError from "./errors/api-error.js";
class ApiRequest extends PolymerElement {
    static get is() {
        return "api-request";
    }
    static get properties() {
        return {
            url: {
                type: String,
            },
            // HTTP method
            method: {
                type: String,
                value: "GET",
            },
            headers: {
                type: Object,
                value: {},
            },
            // Query parameters the are appended to the URL when making a request
            params: {
                type: Object,
            },
            body: {
                type: Object,
            },
            credentials: {
                type: String,
            },
            authorizationRequired: {
                type: Boolean,
                value: false,
            },
            authorizationType: {
                type: String,
            },
            fullResponse: {
                type: Boolean,
                value: false,
            },
            errorsToManuallyHandle: {
                type: Object,
                value: new Set(),
            },
            resource: {
                type: String,
            },
            manuallyHandleError: {
                type: Boolean,
                value: false
            }
        };
    }
    addQueryParameters() {
        const queryParts = [];
        let param;
        let value;
        Object.keys(this.params).map((name) => {
            value = this.params[name];
            param = window.encodeURIComponent(name);
            if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i += 1) {
                    queryParts.push(`${param}=${window.encodeURIComponent(value[i])}`);
                }
            }
            else if (value !== null) {
                queryParts.push(`${param}=${window.encodeURIComponent(value)}`);
            }
            else {
                // NOTE: Pretty sure we dont want this
                // queryParts.push(param);
            }
            return param;
        });
        return queryParts.join("&");
    }
    setHeaders(newHeaders) {
        const headers = Object.assign(this.headers, newHeaders);
        this.set("headers", headers);
    }
    async generateInit() {
        this.setHeaders({
            Accept: "application/json",
            "Content-Type": "application/json",
        });
        const init = {
            method: this.method,
            headers: this.headers,
            mode: "cors",
            cache: "default",
        };
        if (this.body) {
            init.body = JSON.stringify(this.body);
        }
        if (this.authorizationRequired) {
            let authStore;
            try {
                authStore = getDefaultStore().auth;
            }
            catch (e) {
                console.error("Unable to make authorized request: Error getting default store", e);
            }
            console.log('this.authorizationType', this.authorizationType);
            let token;
            if (this.authorizationType === "resource") {
                const auth = await getDefaultStore().auth.getResourceAuth(this.resource);
                token = auth.token;
            }
            else {
                const auth = await authStore.getIdentityAuth();
                token = auth.token;
            }
            if (token)
                init.headers.Authorization = `Bearer ${token}`;
            init.credentials = "include";
        }
        return init;
    }
    static handleErrors(response) {
        if (!response.ok)
            throw response;
        else
            return response;
    }
    dispatchError(error) {
        this.dispatchEvent(new CustomEvent("changeToError", {
            bubbles: true,
            composed: true,
            detail: {
                route: `error`,
                data: {
                    error,
                    pageFrom: window.location.pathname,
                },
            },
        }));
    }
    async generateApiRequest() {
        // console.debug(
        //     "%cAPI-REQUEST debug:",
        //     "color: blue; font-size:10px;",
        //     this.url
        // );
        // console.debug(
        //     "   %cMethod:",
        //     "color: green; font-size:10px;",
        //     this.method
        // );
        // Check URL exists
        if (!this.url)
            return Promise.reject(new Error("No URL was specified."));
        // Assign url to local variable
        let { url } = this;
        // Add query parameters to URL (will only add them if they exist)
        if (this.params) {
            console.debug("adding query parameters");
            url = `${url}?${this.addQueryParameters()}`;
        }
        console.debug(`${this.constructor.is}: Generating Request`, this.url);
        const init = await this.generateInit();
        return fetch(url, init)
            .then(ApiRequest.handleErrors)
            .then((response) => {
            return response.json();
        })
            .then((json) => {
            if (!this.fullResponse)
                return json.data;
            return json;
        })
            .catch((response) => {
            if (this.manuallyHandleError) {
                return response.json();
            }
            if (!response.headers) {
                // This will handle "TypeError: failed to fetch"
                this.dispatchError(response);
                throw new Error(response);
            }
            else {
                const contentType = response.headers.get("content-type");
                // If contentType of response is JSON
                if (contentType &&
                    contentType.indexOf("application/json") !== -1) {
                    return response
                        .json()
                        .then((json) => {
                        if (this.errorsToManuallyHandle &&
                            this.errorsToManuallyHandle.has(json.error.message)) {
                            throw new APIError(json);
                        }
                        else {
                            this.dispatchError(json);
                            throw new APIError(json);
                        }
                    })
                        .catch((error) => {
                        throw error;
                    });
                } // Otherwise the contentType is TEXT
                return response.text().then((text) => {
                    if (this.errorsToManuallyHandle &&
                        this.errorsToManuallyHandle.has(text)) {
                        throw new Error(text);
                    }
                    else {
                        this.dispatchError(text);
                        throw new Error(text);
                    }
                });
            }
        });
    }
}
window.customElements.define(ApiRequest.is, ApiRequest);
//# sourceMappingURL=make-api-request.js.map